import { InputField, LabelTextWrapper, RequiredIndicator } from "./styled";
import { Select } from "antd";

type InputLabelSelectProps = {
  disabled?: boolean;
  labelText: string;
  labelId: string;
  value?: string | number;
  options: { value: number | string; label: string }[];
  onChange?: (value: string) => void;
  tooltipText?: string;
  required?: boolean;
  column?: boolean;
};

const InputLabelSelect: React.FC<InputLabelSelectProps> = ({
  labelText,
  tooltipText,
  disabled,
  labelId,
  value,
  onChange,
  required,
  column,
  options,
}: InputLabelSelectProps) => {
  const onSearch = (value: string) => {
    console.log("search:", value);
  };

  return (
    <InputField
      title={tooltipText}
      className={column ? "columnFormField" : ""}
      htmlFor={labelId}
    >
      <LabelTextWrapper>
        {required ? <RequiredIndicator>* </RequiredIndicator> : <></>}
        <p>{labelText}:</p>
      </LabelTextWrapper>

      <Select
        value={value?.toString()}
        className="select"
        onSearch={onSearch}
        disabled={disabled}
        onChange={onChange}
        optionFilterProp="label"
        title={
          value
            ? options.find((item) => item.value === value)?.label
            : undefined
        }
        options={options.map((opt) => ({
          value: opt.value.toString(),
          label: opt.label,
        }))}
        showSearch
      />
    </InputField>
  );
};

export default InputLabelSelect;
